var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStripeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 50,
    viewBox: "0 0 116 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.384 25.8428C115.384 17.6162 111.41 11.125 103.814 11.125C96.1857 11.125 91.5703 17.6162 91.5703 25.7785C91.5703 35.4511 97.019 40.3356 104.84 40.3356C108.654 40.3356 111.538 39.4679 113.718 38.2468V31.8198C111.538 32.9124 109.038 33.5872 105.865 33.5872C102.756 33.5872 99.9998 32.4947 99.6472 28.7028H115.32C115.32 28.285 115.384 26.614 115.384 25.8428ZM99.5511 22.7899C99.5511 19.1587 101.763 17.6484 103.782 17.6484C105.737 17.6484 107.82 19.1587 107.82 22.7899H99.5511Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1992 11.125C76.0582 11.125 74.039 12.6032 72.9172 13.6315L72.5005 11.6392H65.4492V49.1084L73.462 47.4052L73.4941 38.3111C74.6479 39.1466 76.3467 40.3356 79.1672 40.3356C84.9043 40.3356 90.1287 35.7081 90.1287 25.5214C90.0967 16.2023 84.8082 11.125 79.1992 11.125ZM77.2761 33.2659C75.3851 33.2659 74.2633 32.5911 73.4941 31.7556L73.462 19.8335C74.2954 18.9016 75.4492 18.2589 77.2761 18.2589C80.1928 18.2589 82.212 21.5367 82.212 25.7463C82.212 30.0524 80.2249 33.2659 77.2761 33.2659Z",
    fill: "#635BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4219 9.2274L62.4667 7.49212V0.96875L54.4219 2.6719V9.2274Z",
    fill: "#635BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4667 11.668H54.4219V39.7859H62.4667V11.668Z",
    fill: "#635BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8031 14.0461L45.2903 11.6681H38.3672V39.7861H46.38V20.7301C48.271 18.2557 51.4762 18.7056 52.4698 19.0591V11.6681C51.4441 11.2825 47.6941 10.5755 45.8031 14.0461Z",
    fill: "#635BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7744 4.69531L21.9539 6.36632L21.9219 32.1063C21.9219 36.8623 25.4796 40.365 30.2232 40.365C32.8514 40.365 34.7744 39.883 35.8321 39.3045V32.7812C34.8065 33.1989 29.7424 34.6771 29.7424 29.9212V18.5133H35.8321V11.6686H29.7424L29.7744 4.69531Z",
    fill: "#635BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.10898 19.8335C8.10898 18.5803 9.13462 18.0983 10.8333 18.0983C13.2692 18.0983 16.3462 18.8374 18.7821 20.1549V12.6032C16.1218 11.5428 13.4936 11.125 10.8333 11.125C4.32692 11.125 0 14.5313 0 20.2192C0 29.0884 12.1795 27.6744 12.1795 31.4985C12.1795 32.9767 10.8974 33.4587 9.10256 33.4587C6.44231 33.4587 3.04487 32.3661 0.352564 30.8879V38.536C3.33333 39.8214 6.34615 40.3677 9.10256 40.3677C15.7692 40.3677 20.3526 37.0578 20.3526 31.3057C20.3205 21.7295 8.10898 23.4326 8.10898 19.8335Z",
    fill: "#635BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripe-logo.4bea7ef69d7a682bfe49935ab5e728ff.svg";
export { ForwardRef as ReactComponent };